var map = {
	"./add-circle/bold.svg": [
		82013,
		55684
	],
	"./add-circle/broken.svg": [
		53163,
		22934
	],
	"./add-circle/bulk.svg": [
		71552,
		61177
	],
	"./add-circle/linear.svg": [
		71871,
		71786
	],
	"./add-circle/outline.svg": [
		87982,
		5747
	],
	"./add-circle/twotone.svg": [
		74226,
		62663
	],
	"./add-square/bold.svg": [
		2134,
		96291
	],
	"./add-square/broken.svg": [
		20996,
		7781
	],
	"./add-square/bulk.svg": [
		95475,
		92390
	],
	"./add-square/linear.svg": [
		27588,
		86917
	],
	"./add-square/outline.svg": [
		80027,
		97134
	],
	"./add-square/twotone.svg": [
		21387,
		93502
	],
	"./add/bold.svg": [
		92198,
		18591
	],
	"./add/broken.svg": [
		7732,
		25393
	],
	"./add/bulk.svg": [
		25603,
		41818
	],
	"./add/linear.svg": [
		25684,
		75537
	],
	"./add/outline.svg": [
		16875,
		50890
	],
	"./add/twotone.svg": [
		16603,
		31602
	],
	"./arrow-circle-down/bold.svg": [
		75142,
		25071
	],
	"./arrow-circle-down/broken.svg": [
		32884,
		25377
	],
	"./arrow-circle-down/bulk.svg": [
		27971,
		51850
	],
	"./arrow-circle-down/linear.svg": [
		75828,
		92321
	],
	"./arrow-circle-down/outline.svg": [
		20139,
		94234
	],
	"./arrow-circle-down/twotone.svg": [
		48443,
		47426
	],
	"./arrow-circle-left/bold.svg": [
		84479,
		66462
	],
	"./arrow-circle-left/broken.svg": [
		11249,
		90956
	],
	"./arrow-circle-left/bulk.svg": [
		4626,
		89859
	],
	"./arrow-circle-left/linear.svg": [
		63457,
		74092
	],
	"./arrow-circle-left/outline.svg": [
		4956,
		31641
	],
	"./arrow-circle-left/twotone.svg": [
		53568,
		83685
	],
	"./arrow-circle-right/bold.svg": [
		99704,
		2833
	],
	"./arrow-circle-right/broken.svg": [
		35586,
		2407
	],
	"./arrow-circle-right/bulk.svg": [
		47197,
		85444
	],
	"./arrow-circle-right/linear.svg": [
		89630,
		16323
	],
	"./arrow-circle-right/outline.svg": [
		75641,
		27360
	],
	"./arrow-circle-right/twotone.svg": [
		22193,
		94952
	],
	"./arrow-circle-up/bold.svg": [
		73299,
		50990
	],
	"./arrow-circle-up/broken.svg": [
		15269,
		9692
	],
	"./arrow-circle-up/bulk.svg": [
		43294,
		851
	],
	"./arrow-circle-up/linear.svg": [
		80357,
		4092
	],
	"./arrow-circle-up/outline.svg": [
		89824,
		83337
	],
	"./arrow-circle-up/twotone.svg": [
		21324,
		5845
	],
	"./arrow-down-up/bold.svg": [
		85423,
		68242
	],
	"./arrow-down-up/broken.svg": [
		93057,
		41408
	],
	"./arrow-down-up/bulk.svg": [
		34370,
		4447
	],
	"./arrow-down-up/linear.svg": [
		42129,
		85328
	],
	"./arrow-down-up/outline.svg": [
		20716,
		42173
	],
	"./arrow-down-up/twotone.svg": [
		51024,
		16561
	],
	"./arrow-down/bold.svg": [
		79239,
		43070
	],
	"./arrow-down/broken.svg": [
		67913,
		15436
	],
	"./arrow-down/bulk.svg": [
		21338,
		69347
	],
	"./arrow-down/linear.svg": [
		59545,
		86188
	],
	"./arrow-down/outline.svg": [
		4916,
		53881
	],
	"./arrow-down/twotone.svg": [
		72680,
		61317
	],
	"./arrow-left-right/bold.svg": [
		3721,
		19128
	],
	"./arrow-left-right/broken.svg": [
		37879,
		18890
	],
	"./arrow-left-right/bulk.svg": [
		61140,
		7285
	],
	"./arrow-left-right/linear.svg": [
		36907,
		98750
	],
	"./arrow-left-right/outline.svg": [
		9882,
		81095
	],
	"./arrow-left-right/twotone.svg": [
		45414,
		34611
	],
	"./arrow-left/bold.svg": [
		37422,
		8927
	],
	"./arrow-left/broken.svg": [
		25932,
		77585
	],
	"./arrow-left/bulk.svg": [
		2763,
		89082
	],
	"./arrow-left/linear.svg": [
		83116,
		50481
	],
	"./arrow-left/outline.svg": [
		83779,
		34794
	],
	"./arrow-left/twotone.svg": [
		88995,
		67122
	],
	"./arrow-right/bold.svg": [
		80751,
		65734
	],
	"./arrow-right/broken.svg": [
		609,
		70404
	],
	"./arrow-right/bulk.svg": [
		22370,
		22667
	],
	"./arrow-right/linear.svg": [
		15409,
		60580
	],
	"./arrow-right/outline.svg": [
		15788,
		63761
	],
	"./arrow-right/twotone.svg": [
		73232,
		90989
	],
	"./arrow-up/bold.svg": [
		89177,
		7587
	],
	"./arrow-up/broken.svg": [
		39988,
		35077
	],
	"./arrow-up/bulk.svg": [
		13507,
		3686
	],
	"./arrow-up/linear.svg": [
		54356,
		14213
	],
	"./arrow-up/outline.svg": [
		20651,
		90510
	],
	"./arrow-up/twotone.svg": [
		68603,
		86878
	],
	"./box-add/bold.svg": [
		98782,
		20295
	],
	"./box-add/broken.svg": [
		49148,
		41833
	],
	"./box-add/bulk.svg": [
		22683,
		354
	],
	"./box-add/linear.svg": [
		50332,
		22249
	],
	"./box-add/outline.svg": [
		24115,
		95458
	],
	"./box-add/twotone.svg": [
		6611,
		73562
	],
	"./buildings-2/bold.svg": [
		8651,
		44054
	],
	"./buildings-2/broken.svg": [
		1869,
		50740
	],
	"./buildings-2/bulk.svg": [
		59862,
		79131
	],
	"./buildings-2/linear.svg": [
		73805,
		15828
	],
	"./buildings-2/outline.svg": [
		58792,
		6817
	],
	"./buildings-2/twotone.svg": [
		63236,
		45501
	],
	"./calculator/bold.svg": [
		76907,
		87710
	],
	"./calculator/broken.svg": [
		39789,
		49996
	],
	"./calculator/bulk.svg": [
		96086,
		11107
	],
	"./calculator/linear.svg": [
		34189,
		49484
	],
	"./calculator/outline.svg": [
		22952,
		31609
	],
	"./calculator/twotone.svg": [
		82980,
		67301
	],
	"./calendar/bold.svg": [
		24961,
		82256
	],
	"./calendar/broken.svg": [
		29503,
		59154
	],
	"./calendar/bulk.svg": [
		21580,
		10189
	],
	"./calendar/linear.svg": [
		29171,
		30054
	],
	"./calendar/outline.svg": [
		49314,
		73999
	],
	"./calendar/twotone.svg": [
		85438,
		92715
	],
	"./camera/bold.svg": [
		532,
		92497
	],
	"./camera/broken.svg": [
		76334,
		25863
	],
	"./camera/bulk.svg": [
		58769,
		16452
	],
	"./camera/linear.svg": [
		17930,
		24547
	],
	"./camera/outline.svg": [
		9653,
		71424
	],
	"./camera/twotone.svg": [
		36037,
		96648
	],
	"./card/bold.svg": [
		64449,
		92228
	],
	"./card/broken.svg": [
		29887,
		68086
	],
	"./card/bulk.svg": [
		60972,
		50745
	],
	"./card/linear.svg": [
		64147,
		10954
	],
	"./card/outline.svg": [
		71138,
		58355
	],
	"./card/twotone.svg": [
		77438,
		42535
	],
	"./cards/bold.svg": [
		1910,
		36427
	],
	"./cards/broken.svg": [
		94340,
		49341
	],
	"./cards/bulk.svg": [
		78899,
		40558
	],
	"./cards/linear.svg": [
		932,
		74621
	],
	"./cards/outline.svg": [
		3067,
		77318
	],
	"./cards/twotone.svg": [
		60779,
		44326
	],
	"./chevron-circle-down/bold.svg": [
		51172,
		74353
	],
	"./chevron-circle-down/broken.svg": [
		50398,
		7847
	],
	"./chevron-circle-down/bulk.svg": [
		59905,
		56964
	],
	"./chevron-circle-down/linear.svg": [
		63386,
		21763
	],
	"./chevron-circle-down/outline.svg": [
		70885,
		34816
	],
	"./chevron-circle-down/twotone.svg": [
		1461,
		2408
	],
	"./chevron-circle-left/bold.svg": [
		99373,
		15080
	],
	"./chevron-circle-left/broken.svg": [
		84411,
		73402
	],
	"./chevron-circle-left/bulk.svg": [
		28240,
		94757
	],
	"./chevron-circle-left/linear.svg": [
		37391,
		25198
	],
	"./chevron-circle-left/outline.svg": [
		42942,
		40343
	],
	"./chevron-circle-left/twotone.svg": [
		29570,
		76515
	],
	"./chevron-circle-right/bold.svg": [
		25646,
		49899
	],
	"./chevron-circle-right/broken.svg": [
		27148,
		48189
	],
	"./chevron-circle-right/bulk.svg": [
		36939,
		94126
	],
	"./chevron-circle-right/linear.svg": [
		25100,
		47901
	],
	"./chevron-circle-right/outline.svg": [
		94851,
		38982
	],
	"./chevron-circle-right/twotone.svg": [
		48515,
		83878
	],
	"./chevron-circle-up/bold.svg": [
		86821,
		51188
	],
	"./chevron-circle-up/broken.svg": [
		64803,
		71974
	],
	"./chevron-circle-up/bulk.svg": [
		92456,
		88137
	],
	"./chevron-circle-up/linear.svg": [
		28151,
		60506
	],
	"./chevron-circle-up/outline.svg": [
		88646,
		18435
	],
	"./chevron-circle-up/twotone.svg": [
		75802,
		71671
	],
	"./chevron-down/bold.svg": [
		3645,
		34416
	],
	"./chevron-down/broken.svg": [
		203,
		59314
	],
	"./chevron-down/bulk.svg": [
		94304,
		58925
	],
	"./chevron-down/linear.svg": [
		41279,
		83750
	],
	"./chevron-down/outline.svg": [
		86062,
		80207
	],
	"./chevron-down/twotone.svg": [
		41010,
		67627
	],
	"./chevron-left/bold.svg": [
		41220,
		90137
	],
	"./chevron-left/broken.svg": [
		67934,
		84351
	],
	"./chevron-left/bulk.svg": [
		97409,
		50284
	],
	"./chevron-left/linear.svg": [
		31258,
		23611
	],
	"./chevron-left/outline.svg": [
		93221,
		45656
	],
	"./chevron-left/twotone.svg": [
		27650,
		67376
	],
	"./chevron-right/bold.svg": [
		3661,
		46800
	],
	"./chevron-right/broken.svg": [
		22139,
		30482
	],
	"./chevron-right/bulk.svg": [
		63696,
		74733
	],
	"./chevron-right/linear.svg": [
		48719,
		1382
	],
	"./chevron-right/outline.svg": [
		90846,
		54415
	],
	"./chevron-right/twotone.svg": [
		19202,
		73131
	],
	"./chevron-square-down/bold.svg": [
		6205,
		57956
	],
	"./chevron-square-down/broken.svg": [
		77963,
		5238
	],
	"./chevron-square-down/bulk.svg": [
		12096,
		77945
	],
	"./chevron-square-down/linear.svg": [
		96671,
		66954
	],
	"./chevron-square-down/outline.svg": [
		29550,
		65011
	],
	"./chevron-square-down/twotone.svg": [
		15794,
		40775
	],
	"./chevron-square-left/bold.svg": [
		18948,
		78813
	],
	"./chevron-square-left/broken.svg": [
		20830,
		86643
	],
	"./chevron-square-left/bulk.svg": [
		75041,
		49320
	],
	"./chevron-square-left/linear.svg": [
		33626,
		82607
	],
	"./chevron-square-left/outline.svg": [
		37925,
		63244
	],
	"./chevron-square-left/twotone.svg": [
		66197,
		37868
	],
	"./chevron-square-right/bold.svg": [
		8205,
		24956
	],
	"./chevron-square-right/broken.svg": [
		42728,
		23742
	],
	"./chevron-square-right/bulk.svg": [
		37072,
		77649
	],
	"./chevron-square-right/linear.svg": [
		73327,
		2226
	],
	"./chevron-square-right/outline.svg": [
		88670,
		38107
	],
	"./chevron-square-right/twotone.svg": [
		58946,
		16319
	],
	"./chevron-square-up/bold.svg": [
		44160,
		39813
	],
	"./chevron-square-up/broken.svg": [
		78234,
		28683
	],
	"./chevron-square-up/bulk.svg": [
		21893,
		37264
	],
	"./chevron-square-up/linear.svg": [
		5718,
		88199
	],
	"./chevron-square-up/outline.svg": [
		74257,
		19588
	],
	"./chevron-square-up/twotone.svg": [
		25689,
		88500
	],
	"./chevron-up/bold.svg": [
		87040,
		57273
	],
	"./chevron-up/broken.svg": [
		98330,
		61663
	],
	"./chevron-up/bulk.svg": [
		3301,
		78892
	],
	"./chevron-up/linear.svg": [
		22614,
		80155
	],
	"./chevron-up/outline.svg": [
		67755,
		23544
	],
	"./chevron-up/twotone.svg": [
		40665,
		98160
	],
	"./close-circle/bold.svg": [
		46400,
		71861
	],
	"./close-circle/broken.svg": [
		90298,
		14363
	],
	"./close-circle/bulk.svg": [
		17669,
		24800
	],
	"./close-circle/linear.svg": [
		27062,
		51287
	],
	"./close-circle/outline.svg": [
		21585,
		21268
	],
	"./close-circle/twotone.svg": [
		90553,
		65380
	],
	"./close-square/bold.svg": [
		49183,
		56342
	],
	"./close-square/broken.svg": [
		14545,
		67924
	],
	"./close-square/bulk.svg": [
		33362,
		91419
	],
	"./close-square/linear.svg": [
		45729,
		49364
	],
	"./close-square/outline.svg": [
		70748,
		33217
	],
	"./close-square/twotone.svg": [
		97152,
		71901
	],
	"./close/linear.svg": [
		27615
	],
	"./component/bold.svg": [
		71133,
		55199
	],
	"./component/broken.svg": [
		81416,
		53425
	],
	"./component/bulk.svg": [
		9503,
		78202
	],
	"./component/linear.svg": [
		73032,
		98577
	],
	"./component/outline.svg": [
		84831,
		86282
	],
	"./component/twotone.svg": [
		5559,
		77138
	],
	"./copy/bold.svg": [
		12854,
		60347
	],
	"./copy/broken.svg": [
		46948,
		47149
	],
	"./copy/bulk.svg": [
		6195,
		77950
	],
	"./copy/linear.svg": [
		53540,
		77613
	],
	"./copy/outline.svg": [
		39291,
		25142
	],
	"./copy/twotone.svg": [
		97003,
		84342
	],
	"./document-download/bold.svg": [
		75249,
		99012
	],
	"./document-download/broken.svg": [
		73583,
		6038
	],
	"./document-download/bulk.svg": [
		57519,
		88153
	],
	"./document-download/linear.svg": [
		66979,
		54890
	],
	"./document-download/outline.svg": [
		6930,
		82803
	],
	"./document-download/twotone.svg": [
		52014,
		39719
	],
	"./document-forward/bold.svg": [
		47274,
		67167
	],
	"./document-forward/broken.svg": [
		16968,
		58769
	],
	"./document-forward/bulk.svg": [
		39871,
		90394
	],
	"./document-forward/linear.svg": [
		47240,
		8913
	],
	"./document-forward/outline.svg": [
		30975,
		3946
	],
	"./document-forward/twotone.svg": [
		35127,
		84658
	],
	"./document-previous/bold.svg": [
		35703,
		73129
	],
	"./document-previous/broken.svg": [
		4830,
		50223
	],
	"./document-previous/bulk.svg": [
		14273,
		89500
	],
	"./document-previous/linear.svg": [
		68154,
		59243
	],
	"./document-previous/outline.svg": [
		62642,
		62728
	],
	"./document-previous/twotone.svg": [
		35957,
		32704
	],
	"./document-upload/bold.svg": [
		49396,
		39477
	],
	"./document-upload/broken.svg": [
		97454,
		85755
	],
	"./document-upload/bulk.svg": [
		7633,
		92416
	],
	"./document-upload/linear.svg": [
		39050,
		39031
	],
	"./document-upload/outline.svg": [
		21013,
		7316
	],
	"./document-upload/twotone.svg": [
		47397,
		51428
	],
	"./document/bold.svg": [
		69926,
		26127
	],
	"./document/broken.svg": [
		65460,
		65441
	],
	"./document/bulk.svg": [
		22755,
		69258
	],
	"./document/linear.svg": [
		92052,
		48737
	],
	"./document/outline.svg": [
		68459,
		94714
	],
	"./document/twotone.svg": [
		96763,
		47906
	],
	"./dollar-circle/bold.svg": [
		68004,
		76897
	],
	"./dollar-circle/broken.svg": [
		88478,
		6487
	],
	"./dollar-circle/bulk.svg": [
		40449,
		7700
	],
	"./dollar-circle/linear.svg": [
		1274,
		33875
	],
	"./dollar-circle/outline.svg": [
		27717,
		46000
	],
	"./dollar-circle/twotone.svg": [
		55989,
		21432
	],
	"./double-chevron-left/bold.svg": [
		1986,
		53027
	],
	"./double-chevron-left/broken.svg": [
		30000,
		99333
	],
	"./double-chevron-left/bulk.svg": [
		14743,
		41222
	],
	"./double-chevron-left/linear.svg": [
		86544,
		11237
	],
	"./double-chevron-left/outline.svg": [
		88231,
		11438
	],
	"./double-chevron-left/twotone.svg": [
		50415,
		32670
	],
	"./double-chevron-right/bold.svg": [
		47627,
		55282
	],
	"./double-chevron-right/broken.svg": [
		22861,
		96416
	],
	"./double-chevron-right/bulk.svg": [
		83158,
		63199
	],
	"./double-chevron-right/linear.svg": [
		33613,
		78896
	],
	"./double-chevron-right/outline.svg": [
		34280,
		91485
	],
	"./double-chevron-right/twotone.svg": [
		94308,
		18449
	],
	"./edit-2/bold.svg": [
		23152,
		34457
	],
	"./edit-2/broken.svg": [
		52778,
		54143
	],
	"./edit-2/bulk.svg": [
		60661,
		39724
	],
	"./edit-2/linear.svg": [
		1542,
		72635
	],
	"./edit-2/outline.svg": [
		93313,
		97400
	],
	"./edit-2/twotone.svg": [
		79913,
		72016
	],
	"./element-3/bold.svg": [
		79561,
		31992
	],
	"./element-3/broken.svg": [
		31319,
		11466
	],
	"./element-3/bulk.svg": [
		36980,
		92117
	],
	"./element-3/linear.svg": [
		46699,
		48766
	],
	"./element-3/outline.svg": [
		20282,
		23431
	],
	"./element-3/twotone.svg": [
		55814,
		93299
	],
	"./export/bold.svg": [
		94157,
		30864
	],
	"./export/broken.svg": [
		78779,
		65042
	],
	"./export/bulk.svg": [
		84368,
		75149
	],
	"./export/linear.svg": [
		60783,
		35942
	],
	"./export/outline.svg": [
		94430,
		20431
	],
	"./export/twotone.svg": [
		98626,
		39147
	],
	"./eye-slash/bold.svg": [
		184,
		81385
	],
	"./eye-slash/broken.svg": [
		34658,
		96719
	],
	"./eye-slash/bulk.svg": [
		31325,
		10268
	],
	"./eye-slash/linear.svg": [
		88702,
		70443
	],
	"./eye-slash/outline.svg": [
		11737,
		12872
	],
	"./eye-slash/twotone.svg": [
		58289,
		42304
	],
	"./eye/bold.svg": [
		31672,
		94193
	],
	"./eye/broken.svg": [
		82946,
		51911
	],
	"./eye/bulk.svg": [
		62813,
		94852
	],
	"./eye/linear.svg": [
		36990,
		3395
	],
	"./eye/outline.svg": [
		85625,
		17856
	],
	"./eye/twotone.svg": [
		32177,
		64040
	],
	"./filter/bold.svg": [
		21625,
		59076
	],
	"./filter/broken.svg": [
		92583,
		89142
	],
	"./filter/bulk.svg": [
		35940,
		79065
	],
	"./filter/linear.svg": [
		50971,
		50858
	],
	"./filter/outline.svg": [
		95114,
		55059
	],
	"./filter/twotone.svg": [
		98614,
		30823
	],
	"./global/bold.svg": [
		7892,
		79933
	],
	"./global/broken.svg": [
		35726,
		49139
	],
	"./global/bulk.svg": [
		10257,
		10344
	],
	"./global/linear.svg": [
		28074,
		54863
	],
	"./global/outline.svg": [
		74389,
		71564
	],
	"./global/twotone.svg": [
		7269,
		27180
	],
	"./grid/bold.svg": [
		16151,
		14458
	],
	"./grid/broken.svg": [
		63769,
		62456
	],
	"./grid/bulk.svg": [
		25162,
		45671
	],
	"./grid/linear.svg": [
		88265,
		79624
	],
	"./grid/outline.svg": [
		86628,
		27701
	],
	"./grid/twotone.svg": [
		24760,
		33977
	],
	"./home/bold.svg": [
		59572,
		65613
	],
	"./home/broken.svg": [
		40526,
		13699
	],
	"./home/bulk.svg": [
		95857,
		91992
	],
	"./home/linear.svg": [
		15722,
		17631
	],
	"./home/outline.svg": [
		27285,
		33660
	],
	"./home/twotone.svg": [
		87365,
		16796
	],
	"./import/bold.svg": [
		75174,
		70235
	],
	"./import/broken.svg": [
		25204,
		64109
	],
	"./import/bulk.svg": [
		28003,
		49182
	],
	"./import/linear.svg": [
		51796,
		8557
	],
	"./import/outline.svg": [
		77995,
		94326
	],
	"./import/twotone.svg": [
		6299,
		59926
	],
	"./info-circle/bold.svg": [
		41646,
		43279
	],
	"./info-circle/broken.svg": [
		29868,
		46017
	],
	"./info-circle/bulk.svg": [
		69291,
		86410
	],
	"./info-circle/linear.svg": [
		11468,
		12961
	],
	"./info-circle/outline.svg": [
		60867,
		34170
	],
	"./info-circle/twotone.svg": [
		30883,
		87362
	],
	"./info-danger/bold.svg": [
		45413,
		68876
	],
	"./info-danger/broken.svg": [
		89411,
		49166
	],
	"./info-danger/bulk.svg": [
		15848,
		57505
	],
	"./info-danger/linear.svg": [
		20215,
		92546
	],
	"./info-danger/outline.svg": [
		52454,
		93771
	],
	"./info-danger/twotone.svg": [
		12250,
		56847
	],
	"./info-shape/bold.svg": [
		45067,
		65230
	],
	"./info-shape/broken.svg": [
		44877,
		9404
	],
	"./info-shape/bulk.svg": [
		64246,
		49491
	],
	"./info-shape/linear.svg": [
		61658,
		58044
	],
	"./info-shape/outline.svg": [
		22472,
		91977
	],
	"./info-shape/twotone.svg": [
		82500,
		51573
	],
	"./info-warning/bold.svg": [
		36726,
		28459
	],
	"./info-warning/broken.svg": [
		57316,
		2314
	],
	"./info-warning/bulk.svg": [
		52448,
		32590
	],
	"./info-warning/linear.svg": [
		63908,
		21565
	],
	"./info-warning/outline.svg": [
		67899,
		29766
	],
	"./info-warning/twotone.svg": [
		25611,
		13126
	],
	"./info/bold.svg": [
		26819,
		37202
	],
	"./info/broken.svg": [
		66805,
		78080
	],
	"./info/bulk.svg": [
		4225,
		73407
	],
	"./info/linear.svg": [
		14997
	],
	"./info/outline.svg": [
		8272,
		70013
	],
	"./info/twotone.svg": [
		48636,
		28049
	],
	"./list/linear.svg": [
		9817,
		38052
	],
	"./location/bold.svg": [
		30284,
		86297
	],
	"./location/broken.svg": [
		92886,
		6687
	],
	"./location/bulk.svg": [
		25673,
		46444
	],
	"./location/linear.svg": [
		63026,
		62299
	],
	"./location/outline.svg": [
		89578,
		72792
	],
	"./location/twotone.svg": [
		46109,
		94512
	],
	"./login/bold.svg": [
		20624,
		52781
	],
	"./login/broken.svg": [
		36714,
		19459
	],
	"./login/bulk.svg": [
		41781,
		99288
	],
	"./login/linear.svg": [
		85478,
		43359
	],
	"./login/outline.svg": [
		27073,
		64956
	],
	"./login/twotone.svg": [
		13673,
		67196
	],
	"./logout/bold.svg": [
		18130,
		56204
	],
	"./logout/broken.svg": [
		84291,
		30382
	],
	"./logout/bulk.svg": [
		49832,
		72865
	],
	"./logout/linear.svg": [
		15095,
		79522
	],
	"./logout/outline.svg": [
		19302,
		18155
	],
	"./logout/twotone.svg": [
		79098,
		52175
	],
	"./magic-pen/bold.svg": [
		57428,
		22257
	],
	"./magic-pen/broken.svg": [
		71438,
		52935
	],
	"./magic-pen/bulk.svg": [
		32017,
		22916
	],
	"./magic-pen/linear.svg": [
		13034,
		88067
	],
	"./magic-pen/outline.svg": [
		1973,
		70176
	],
	"./magic-pen/twotone.svg": [
		28357,
		32712
	],
	"./message-notif/bold.svg": [
		68501,
		37300
	],
	"./message-notif/broken.svg": [
		80051,
		56070
	],
	"./message-notif/bulk.svg": [
		60504,
		31273
	],
	"./message-notif/linear.svg": [
		81927,
		70778
	],
	"./message-notif/outline.svg": [
		2742,
		10979
	],
	"./message-notif/twotone.svg": [
		75914,
		67735
	],
	"./minus-cirlce/bold.svg": [
		66010,
		35931
	],
	"./minus-cirlce/broken.svg": [
		18744,
		97965
	],
	"./minus-cirlce/bulk.svg": [
		65007,
		98526
	],
	"./minus-cirlce/linear.svg": [
		97240,
		42413
	],
	"./minus-cirlce/outline.svg": [
		11663,
		88630
	],
	"./minus-cirlce/twotone.svg": [
		72167,
		54230
	],
	"./minus/bold.svg": [
		85745,
		42808
	],
	"./minus/broken.svg": [
		12047,
		5578
	],
	"./minus/bulk.svg": [
		74044,
		41461
	],
	"./minus/linear.svg": [
		5443,
		16062
	],
	"./minus/outline.svg": [
		85266,
		2215
	],
	"./minus/twotone.svg": [
		46702,
		15155
	],
	"./money-send/bold.svg": [
		18510,
		40163
	],
	"./money-send/broken.svg": [
		58444,
		75973
	],
	"./money-send/bulk.svg": [
		32363,
		36262
	],
	"./money-send/linear.svg": [
		18924,
		38757
	],
	"./money-send/outline.svg": [
		24355,
		37038
	],
	"./money-send/twotone.svg": [
		16771,
		33406
	],
	"./more-horizontal/bold.svg": [
		97145,
		22420
	],
	"./more-horizontal/broken.svg": [
		96103,
		85318
	],
	"./more-horizontal/bulk.svg": [
		98660,
		16393
	],
	"./more-horizontal/linear.svg": [
		58939,
		26
	],
	"./more-horizontal/outline.svg": [
		80106,
		77155
	],
	"./more-horizontal/twotone.svg": [
		16854,
		33911
	],
	"./more-vertical/bold.svg": [
		49996,
		71010
	],
	"./more-vertical/broken.svg": [
		26545,
		42192
	],
	"./more-vertical/bulk.svg": [
		64818,
		95471
	],
	"./more-vertical/linear.svg": [
		71713
	],
	"./more-vertical/outline.svg": [
		93052,
		86317
	],
	"./more-vertical/twotone.svg": [
		99520,
		57281
	],
	"./notification-2/bold.svg": [
		72383,
		79934
	],
	"./notification-2/broken.svg": [
		28369,
		21004
	],
	"./notification-2/bulk.svg": [
		23378,
		37379
	],
	"./notification-2/linear.svg": [
		54305,
		3436
	],
	"./notification-2/outline.svg": [
		6076,
		41305
	],
	"./notification-2/twotone.svg": [
		60211,
		11269
	],
	"./pix/linear.svg": [
		33722,
		14407
	],
	"./profile-2user/bold.svg": [
		39428,
		62741
	],
	"./profile-2user/broken.svg": [
		926,
		83867
	],
	"./profile-2user/bulk.svg": [
		95521,
		9088
	],
	"./profile-2user/linear.svg": [
		13722,
		54871
	],
	"./profile-2user/outline.svg": [
		56837,
		58036
	],
	"./profile-2user/twotone.svg": [
		68757,
		96676
	],
	"./profile-tick/bold.svg": [
		47962,
		28291
	],
	"./profile-tick/broken.svg": [
		90328,
		61477
	],
	"./profile-tick/bulk.svg": [
		2703,
		96966
	],
	"./profile-tick/linear.svg": [
		30187,
		97221
	],
	"./profile-tick/outline.svg": [
		17551,
		28910
	],
	"./profile-tick/twotone.svg": [
		68135,
		77054
	],
	"./profile/bold.svg": [
		96436,
		50417
	],
	"./profile/broken.svg": [
		66222,
		6023
	],
	"./profile/bulk.svg": [
		15057,
		33028
	],
	"./profile/linear.svg": [
		56266,
		19939
	],
	"./profile/outline.svg": [
		72770,
		99744
	],
	"./profile/twotone.svg": [
		56549,
		67336
	],
	"./question/linear.svg": [
		64181,
		38912
	],
	"./refresh/bold.svg": [
		90566,
		21671
	],
	"./refresh/broken.svg": [
		34228,
		49609
	],
	"./refresh/bulk.svg": [
		8867,
		39778
	],
	"./refresh/linear.svg": [
		48596,
		27753
	],
	"./refresh/outline.svg": [
		72939,
		64002
	],
	"./refresh/twotone.svg": [
		20891,
		22650
	],
	"./search-normal/bold.svg": [
		79249,
		63384
	],
	"./search-normal/broken.svg": [
		22063,
		85770
	],
	"./search-normal/bulk.svg": [
		53071,
		39861
	],
	"./search-normal/linear.svg": [
		19363,
		6718
	],
	"./search-normal/outline.svg": [
		54437,
		73639
	],
	"./search-normal/twotone.svg": [
		81390,
		43507
	],
	"./settings/bold.svg": [
		2674,
		73239
	],
	"./settings/broken.svg": [
		67296,
		96473
	],
	"./settings/bulk.svg": [
		95847,
		82226
	],
	"./settings/linear.svg": [
		29632,
		98361
	],
	"./settings/outline.svg": [
		95703,
		72658
	],
	"./settings/twotone.svg": [
		69439,
		5290
	],
	"./shop-add/bold.svg": [
		43385,
		59980
	],
	"./shop-add/broken.svg": [
		2887,
		93678
	],
	"./shop-add/bulk.svg": [
		72196,
		60289
	],
	"./shop-add/linear.svg": [
		57499,
		10754
	],
	"./shop-add/outline.svg": [
		96778,
		44971
	],
	"./shop-add/twotone.svg": [
		59830,
		96623
	],
	"./shop/bold.svg": [
		50959,
		13594
	],
	"./shop/broken.svg": [
		31137,
		45784
	],
	"./shop/bulk.svg": [
		92578,
		44455
	],
	"./shop/linear.svg": [
		45937,
		42856
	],
	"./shop/outline.svg": [
		34892,
		75797
	],
	"./shop/twotone.svg": [
		92336,
		34393
	],
	"./shopping-cart/bold.svg": [
		47300,
		86165
	],
	"./shopping-cart/broken.svg": [
		32766,
		55035
	],
	"./shopping-cart/bulk.svg": [
		58977,
		40064
	],
	"./shopping-cart/linear.svg": [
		80026,
		14551
	],
	"./shopping-cart/outline.svg": [
		12325,
		80916
	],
	"./shopping-cart/twotone.svg": [
		93493,
		95140
	],
	"./slash/bold.svg": [
		88872,
		2385
	],
	"./slash/broken.svg": [
		69970,
		86759
	],
	"./slash/bulk.svg": [
		6957,
		26340
	],
	"./slash/linear.svg": [
		72078,
		85443
	],
	"./slash/outline.svg": [
		46633,
		49600
	],
	"./slash/twotone.svg": [
		47233,
		74824
	],
	"./spinner/linear.svg": [
		78130
	],
	"./status-up/bold.svg": [
		37685,
		30268
	],
	"./status-up/broken.svg": [
		35795,
		50046
	],
	"./status-up/bulk.svg": [
		60536,
		21489
	],
	"./status-up/linear.svg": [
		78119,
		20082
	],
	"./status-up/outline.svg": [
		87062,
		9435
	],
	"./status-up/twotone.svg": [
		3818,
		36927
	],
	"./tick-circle/bold.svg": [
		65517,
		10240
	],
	"./tick-circle/broken.svg": [
		60475,
		80034
	],
	"./tick-circle/bulk.svg": [
		9200,
		42653
	],
	"./tick-circle/linear.svg": [
		3407,
		38550
	],
	"./tick-circle/outline.svg": [
		49022,
		41087
	],
	"./tick-circle/twotone.svg": [
		77378,
		6523
	],
	"./tick/bold.svg": [
		8822,
		34523
	],
	"./tick/broken.svg": [
		69188,
		4045
	],
	"./tick/bulk.svg": [
		44691,
		68478
	],
	"./tick/linear.svg": [
		65124
	],
	"./tick/outline.svg": [
		31483,
		64950
	],
	"./tick/twotone.svg": [
		15275,
		7798
	],
	"./trash/bold.svg": [
		84739,
		6738
	],
	"./trash/broken.svg": [
		8917,
		26176
	],
	"./trash/bulk.svg": [
		84526,
		14655
	],
	"./trash/linear.svg": [
		57109,
		8656
	],
	"./trash/outline.svg": [
		89456,
		50173
	],
	"./trash/twotone.svg": [
		29820,
		93489
	],
	"./trend-down/bold.svg": [
		44173,
		49604
	],
	"./trend-down/broken.svg": [
		4219,
		99254
	],
	"./trend-down/bulk.svg": [
		34384,
		8121
	],
	"./trend-down/linear.svg": [
		69871,
		42122
	],
	"./trend-down/outline.svg": [
		75070,
		60563
	],
	"./trend-down/twotone.svg": [
		79266,
		44743
	],
	"./trend-up/bold.svg": [
		19920,
		35973
	],
	"./trend-up/broken.svg": [
		34602,
		8331
	],
	"./trend-up/bulk.svg": [
		64597,
		33968
	],
	"./trend-up/linear.svg": [
		92646,
		76583
	],
	"./trend-up/outline.svg": [
		10561,
		3492
	],
	"./trend-up/twotone.svg": [
		99049,
		71604
	],
	"./user/bold.svg": [
		72944,
		50885
	],
	"./user/broken.svg": [
		71562,
		63883
	],
	"./user/bulk.svg": [
		94325,
		57136
	],
	"./user/linear.svg": [
		80294,
		75399
	],
	"./user/outline.svg": [
		40993,
		63172
	],
	"./user/twotone.svg": [
		2633,
		51540
	],
	"./wallet/bold.svg": [
		73470,
		36751
	],
	"./wallet/broken.svg": [
		61020,
		28513
	],
	"./wallet/bulk.svg": [
		48955,
		6058
	],
	"./wallet/linear.svg": [
		82172,
		66817
	],
	"./wallet/outline.svg": [
		43347,
		37402
	],
	"./wallet/twotone.svg": [
		92595,
		85922
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 91305;
module.exports = webpackAsyncContext;